const stripTrailingSlash = (value = '') => value.replace(/\/+$/, '');

const joinUrl = (baseUrl = '', path = '') => {
  const normalizedBaseUrl = stripTrailingSlash(baseUrl);
  const normalizedPath = String(path || '').replace(/^\/+/, '');

  if (!normalizedPath) {
    return normalizedBaseUrl;
  }

  return `${normalizedBaseUrl}/${normalizedPath}`;
};

export const getApiBaseUrl = () => {
  const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL;
  if (configuredBaseUrl) {
    return stripTrailingSlash(configuredBaseUrl);
  }

  if (process.env.REACT_APP_ENVIRONMENT === 'render_private') {
    return '/api';
  }

  const legacyBaseUrl = process.env.REACT_APP_API_URL_NGINX || process.env.REACT_APP_API_URL_BACK;
  return stripTrailingSlash(legacyBaseUrl || '');
};

export const getApiUrlFromBase = (path = '') => {
  const baseUrl = getApiBaseUrl();
  if (!baseUrl) {
    return '';
  }

  return joinUrl(baseUrl, path);
};
